<template>
    <TenderTable :api_url="$store.state.api_url+ '/tender/get_all'" :search="true" />
</template>

<script>
    import TenderTable  from '@/components/TenderTable.vue';
    export default {
        components: {
            TenderTable,
        },
    }

</script>
